module.exports = __webpack_public_path__ + "static/media/spinner.08554c66.glb";